function parseItem(str) {
  const idx = str.lastIndexOf("::");
  if (idx === -1) return { name: str, qty: 1 };
  return { name: str.slice(0, idx), qty: parseInt(str.slice(idx + 2)) || 1 };
}

export default function NeedsPanel({ requests, contributions }) {
  if (!requests || requests.length === 0) return null;

  const requestsWithCoverage = requests.map(req => {
    const covered = contributions.reduce((sum, c) => {
      for (const item of (c.items || [])) {
        const { name, qty } = parseItem(item);
        if (name === req.item_name) return sum + qty;
      }
      return sum;
    }, 0);
    return { ...req, covered, isCovered: covered >= req.quantity_needed };
  });

  const allCovered   = requestsWithCoverage.every(r => r.isCovered);
  const headerColor  = allCovered ? "#00e676" : "#cc2200";
  const headerBorder = allCovered ? "#00e676" : "#cc2200";
  const headerIcon   = allCovered ? "✅" : "⚠️";
  const headerSuffix = allCovered ? " (¡conseguido!)" : "";

  return (
    <div className="card" style={{ marginBottom: 24, borderLeft: `3px solid ${headerBorder}` }}>
      <h3 style={{ fontSize: 13, letterSpacing: 2, textTransform: "uppercase", color: headerColor, margin: "0 0 16px" }}>
        {headerIcon} Equipo prioritario<span style={{ letterSpacing: 1 }}>{headerSuffix}</span>
      </h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {requestsWithCoverage.map(req => {
          const { isCovered, covered } = req;
          const isPartial  = covered > 0 && !isCovered;
          const statusColor = isCovered ? "#00e676" : isPartial ? "#ffd600" : "#cc2200";
          const statusIcon  = isCovered ? "✅" : isPartial ? "⚡" : "⚠️";

          return (
            <div key={req.id} style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <span style={{ fontSize: 13, color: isCovered ? "#555" : "#fff", textDecoration: isCovered ? "line-through" : "none" }}>
                  {req.item_name}
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: statusColor, fontVariantNumeric: "tabular-nums" }}>
                  {covered}/{req.quantity_needed}
                </div>
                <div style={{ fontSize: 14 }}>{statusIcon}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
